import {Address} from './client';
import {Domain} from './domain';
import {RecipientFee} from './fee';
import {LegalRepresentative} from './person';
import {Wallet} from './wallet';

export interface Recipient {
  id: number;
  name: string;
  document: string;
  identifier: string;
  domain: Domain;
  email: string;
  sandbox: boolean;
  status: RecipientStatus;
  representative?: LegalRepresentative;
  createdAt: Date;
  updatedAt: Date;
  documents: {
    id: number;
    fileUrl: string;
  }[];
  metadata?: RecipientMetadata;
  businessAreas: RecipientBusinessArea[];
  address: Address;
  logo: string;
  fees: RecipientFee[];
  wallet: Wallet;
  isLegalPerson: boolean;
  standalone: boolean;
  officialData: RecipientOfficialData;
  provider: string;
}

export enum RecipientBusinessArea {
  ECOMMERCE = 'ecommerce',
  SOFTWARE_AS_A_SERVICE = 'software_as_a_service',
  SUBSCRIPTION_SERVICE = 'subscription_service',
  PAYMENT_FACILITATION = 'payment_facilitation',
  PAYMENT_GATEWAY = 'payment_gateway',
  ONLINE_BETTING = 'online_betting',
  RELIGIOUS_ENTITIES = 'religious_entities',
  LUXURY_ITEMS = 'luxury_items',
  TICKETING = 'ticketing',
  CONSULTING = 'consulting',
  TRAVEL_TOURISM = 'travel_tourism',
  CRYPTO = 'crypto',
  ADULT_ENTERTAINMENT = 'adult_entertainment',
  OTHER = 'other',
}

export enum RecipientStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  PENDING_COMPLIANCE = 'pending_compliance',
  REGISTRATION_INCOMPLETE = 'registration_incomplete',
  FAILED_COMPLIANCE = 'failed_compliance',
  SUSPENDED = 'suspended',
}

export interface RecipientMetadata {
  riskIndex?: number;
  ipAddress?: string;
  userAgent?: string;
}

export interface RecipientKey {
  id: number;
  key: string;
  secret: string;
  enabled: boolean;
  description?: string;
  allowList: string[];
  recipient?: Recipient;
  domain?: Domain;
  createdAt: Date;
  updatedAt: Date;
  lastActivity?: {
    createdAt: Date;
  };
}

export interface RecipientOfficialData {
  updated: string;
  taxId: string;
  alias: string;
  founded: string;
  head: boolean;
  company: Company;
  statusDate: string;
  status: OfficialDataStatus;
  address: OfficialDataAddress;
  mainActivity: MainActivity;
  phones: Phone[];
  emails: Email[];
  sideActivities: SideActivity[];
  registrations: unknown[];
  suframa: unknown[];
}

export interface Company {
  members: Member[];
  id: number;
  name: string;
  equity: number;
  nature: Nature;
  size: Size;
  simples: Simples;
  simei: Simei;
}

export interface Member {
  since: string;
  person: Person;
  role: Role;
}

export interface Person {
  id: string;
  type: string;
  name: string;
  taxId: string;
  age: string;
}

export interface Role {
  id: number;
  text: string;
}

export interface Nature {
  id: number;
  text: string;
}

export interface Size {
  id: number;
  acronym: string;
  text: string;
}

export interface Simples {
  optant: boolean;
  since: string;
}

export interface Simei {
  optant: boolean;
  since: unknown;
}

export interface OfficialDataStatus {
  id: number;
  text: string;
}

export interface OfficialDataAddress {
  municipality: number;
  street: string;
  number: string;
  district: string;
  city: string;
  state: string;
  details: unknown;
  zip: string;
  country: Country;
}

export interface Country {
  id: number;
  name: string;
}

export interface MainActivity {
  id: number;
  text: string;
}

export interface Phone {
  type: string;
  area: string;
  number: string;
}

export interface Email {
  ownership: string;
  address: string;
  domain: string;
}

export interface SideActivity {
  id: number;
  text: string;
}
